import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
	setMappingStatus,
	fetchMappingInfo,
	changeCurrentPath,
	resetMainListState,
	resetConsigneeListStateNew,
} from '../../../actions';
import classNames from 'classnames';
import Dropzone from 'react-dropzone'
import {getFileSize} from '../../../common/utils/files';

import Header from '../../../common/containers/header';
import Progress from '../../../common/containers/progress'
import SpNav from '../../../common/containers/sp_nav'
import Footer from '../../../common/containers/footer';
import MainButtons from '../../../common/components/main-buttons';

import ErrorDialog from '../../../common/components/dialog/error-dialog';
import ReloadModal from '../../../common/components/dialog/reload-dialog';
import LogoutModal from '../../../common/components/dialog/logout-dialog';

import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import red from '@material-ui/core/colors/red';
import Stepper from '../components/stepper'
import Encoding from "encoding-japanese";
import csv from 'csvtojson';

const styles = theme => ({
	abortButton:{
		backgroundColor:red[500],
		'&:hover': {
			backgroundColor: red[800],
		},
		color: theme.palette.getContrastText(red[500]),
	},
	cautionText:{
		marginBottom:30,
		padding:10,
		borderTop:'rgba(0,0,0,0.05) solid 5px',
		borderBottom:'rgba(0,0,0,0.05) solid 5px',
		fontSize : '85%'
	},
	cautionAddText:{
		color:red[800]
	},
	selectTemplate:{
		marginBottom: 20
	},
	dropArea:{
		paddingTop:"110px !important",
		paddingBottom:"110px !important",
	}
});


class MappingStep1 extends Component {
	constructor(props) {
		super(props);
		const processDivide = !("divide" in props.match.params) || !props.match.params.divide ? "1" : props.match.params.divide;
		this.state = {
			dragging : false,
			readFile : {},
			readColumns : [],
			errorContents : null,
			templateValue : '',
			processDivide
		}
	}

	/** override methods **/
	UNSAFE_componentWillMount() {
		const {dispatch} = this.props;
		if(this.state.currentFormValues !== {}){
			this.getMappingSettingInfo();
		}
		dispatch(resetMainListState());
		dispatch(resetConsigneeListStateNew());

	}
	componentDidMount() {
		const { dispatch, history } = this.props;
		window.scrollTo(0, 0);
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
	}


	/** event handlers **/
	handleDrop =()=> {
		this.setState({dragging:false});
	};

	handleDragEnter =(e) => {
		this.setState({dragging:true});
	};

	handleDragLeave = (e) => {
		this.setState({dragging:false});
	};

	handleDropAccepted =(files) => {
		files.forEach((file,index)=>{
			const reader = new FileReader();
			reader.readAsArrayBuffer(file);
			reader.onload = (e) => {
				const codes = new Uint8Array(e.target.result);
				const encoding = (Encoding.detect(codes) === "UNICODE") ? "SJIS" : Encoding.detect(codes);
				const unicodeString = Encoding.convert(codes, {
					to: 'unicode',
					from: encoding,
					type: 'string',
				});
				let cols = unicodeString.split('\n');

				csv({
					noheader:true,
					output: "csv",
					flatKeys:true
				}).fromString(cols[0]).then((csvRow)=>{
					if(csvRow.length === 0){
						this.setState({
							errorContents:"NO_ROW"
						})
					}
					else{
						this.setState({
							readFile:{name:file.name,size:getFileSize(file.size)},
							readColumns:csvRow[0]
						});
					}
				});
			};
		});
	};


	handleDropRejected = (files) => {
		const errorContents = (files.length>1) ? "MULTIPLE" : "NOT_SUPPORT_TYPE";
		this.setState({errorContents});
	};

	handleClickDeleteFile = () =>{
		this.setState({
			readFile:{},
			readColumns:[]
		})
	};

	handleChangeTemplateValue = (event) =>{
		this.setState({
			templateValue : event.target.value
		});
	};

	handleClearErrors = () =>{
		this.setState({
			errorContents:null
		})
	};

	handleClickNext = () =>{
		const {templateValue, readColumns} = this.state;
		const {history, dispatch, settings} = this.props;
		if(templateValue === ''){
			dispatch(setMappingStatus({
				source:readColumns,
				target:settings.defaultTarget,
				processDivide:this.state.processDivide
			}));
		}
		else{
			const selectedTemplateInfo = settings.templateInfo[templateValue];
			dispatch(setMappingStatus({
				source:selectedTemplateInfo.sourceColumn,
				target:selectedTemplateInfo.mappingState,
				templateName:selectedTemplateInfo.templateName,
				templateID:selectedTemplateInfo.templateID,
				processDivide:this.state.processDivide
			}));
		}

		history.push('/mapping/step2/'+this.state.processDivide);

	};

	handleClickBackList = () =>{
		if(this.state.processDivide === "1"){
			this.props.history.push('/main-list');
		}
		else{
			this.props.history.push('/shipment');
		}
	};

	handleClickBackUpload = () =>{
		this.props.history.push('/upload/'+this.state.processDivide);
	};

	/** Private Method **/
	getMappingSettingInfo = () =>{
		const { dispatch, auth } = this.props;
		dispatch(fetchMappingInfo({
			SessionID : auth.SessionID,
			processDivide:this.state.processDivide
		}));
	};




	render() {
		const {classes,settings} = this.props;
		const {readFile,errorContents,templateValue,processDivide} = this.state;

		const errorOpen = (errorContents !== null);
		let message;
		if(errorOpen){
			message = (errorContents === "MULTIPLE") ? <span>複数のファイルを同時にアップロードすることはできません</span> :
					  (errorContents === "NOT_SUPPORT_TYPE") ? <span>読み込み可能な形式はCSV形式のみです</span>
						  							: <span>ファイルにレコードが存在しません</span>;
		}

		const nextDisabled = templateValue === '' && Object.keys(readFile).length === 0;

		const mainButtons = [
			{type:'NEXT',func:this.handleClickNext,text:"次へ",disabled:nextDisabled},
			{type:'BACK',func:this.handleClickBackUpload,text:"UPLOAD"},
		];


		const navigations = [
			{name:processDivide === "2" ? '車番登録' : '一覧',clickFunc:this.handleClickBackList},
			{name:(processDivide === "2" ? '車番情報' : '') + 'CSVアップロード',clickFunc:this.handleClickBackUpload}
		];


		const templateInfo = settings.templateInfo;




		return (
			<div id="main_container">
				{(settings.isFetching) &&
				<Progress/>
				}
				<SpNav history={this.props.history}/>
				<Header history={this.props.history} navigations={navigations}/>
				<article>
					<section className="title_area">
						<h2>テンプレートマッピング</h2>
					</section>
					<section className="with_button">
						<Stepper activeStep={0}/>
						<p className={classes.cautionText}>
							新しく登録したいテンプレートのCSVファイルを指定エリアにドロップし、次へを押して下さい。<br />
							既存のテンプレートの編集を行いたい場合は、テンプレートを下の選択ボックスから選択し、「次へ」で編集へ進みます
						</p>
					</section>
					<section className={"with_button"}>
						<FormControl className={classes.selectTemplate} fullWidth>
							<InputLabel shrink id="demo-simple-select-placeholder-label-label">
								テンプレートの選択
							</InputLabel>
							<Select
								value={templateValue}
								onChange={this.handleChangeTemplateValue}
								displayEmpty
							>
								<MenuItem value="">
									新しくテンプレートを作成する
								</MenuItem>
								{templateInfo.map((info,index)=>{
									return(
										<MenuItem value={index} key={index}>
											{info.templateName}
										</MenuItem>
									)
								})}
							</Select>
						</FormControl>
					</section>
					{templateValue === '' &&
					<section id="uploads" className="with_button">
						<Dropzone
							className={classNames("uploads_dropzone", {"is_over": this.state.dragging},classes.dropArea)}
							onDrop={this.handleDrop}
							onDragEnter={this.handleDragEnter}
							onDragLeave={this.handleDragLeave}
							onDropAccepted={this.handleDropAccepted}
							onDropRejected={this.handleDropRejected}
							accept=".csv"
							multiple={false}
						>
							<div className="uploads_dropzone_inner">
								ここにファイルをドロップしてください。
								<span>※UTF-8エンコード以外のCSVファイルは文字化けを起こす可能性があります</span>
							</div>
						</Dropzone>
						{Object.keys(readFile).length > 0 &&
						<div className="statusbar">
							<div className="filename">{readFile.name}</div>
							<div className="filesize">{readFile.size}</div>
							<div className="progewssBar">
								<div>読み込み完了</div>
							</div>
							<Button
								className={classNames('abort', classes.abortButton)}
								onClick={this.handleClickDeleteFile}
							>
								取消
							</Button>
						</div>
						}
					</section>
					}
				</article>
				<MainButtons buttons={mainButtons}/>
				<Footer/>
				<ErrorDialog
					open={errorOpen}
					text={message}
					afterCloseFunc={this.handleClearErrors}
				/>
				<ErrorDialog
					open={settings.isProcessError}
				/>
				<ReloadModal />
				<LogoutModal />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		navigation : state.navigation,
		auth: state.auth,
		settings : state.mappingSettings
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(MappingStep1);




// WEBPACK FOOTER //
// ./src/routes/mapping/step1/index.js